import { PRESENTLEVELS_EVENT_NAMES } from '@/presentlevels/event_names'

export const SHARED_STATEMENT_EVENT_NAMES = {
  VIEWED: PRESENTLEVELS_EVENT_NAMES.VIEWED_SHARED_STATEMENT,
  CLICKED_COPY_STATEMENT: 'Clicked Copy Statement from Drafted'
}
